import React, { useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import NavLink from '../atoms/NavLink';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { checkAuthState } from '../../redux/slices/authSlice';
import { ThunkDispatch, Action } from '@reduxjs/toolkit';

const NavLinksMolecule: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<RootState, void, Action>>()
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(checkAuthState());
  }, [dispatch]);


  // Show all navigation items if user is super admin
  if (isAuthenticated && user && user.role === 'super_admin') {
    return (
      <Nav className="me-auto">
        <NavLink to="/vitalsboard" label="Vitals Board" />
        <NavLink to="/patients" label="Patients" />
        <NavLink to="/sessions" label="Sessions" />
        <NavLink to="/account" label="Account" />
        <NavLink to="/logout" label='Logout' />
        <div className="divider" />
        <NavLink to="/devices" label="Devices" />
        <div className="divider" />
        <NavLink to="/customers" label="Customers" />
        <NavLink to="/partners" label="Partners" />
      </Nav>
    );
  }

  if (isAuthenticated && user && user.role === 'partner_admin') {
      return (
      <Nav className="me-auto">
        <NavLink to="/vitalsboard" label="Vitals Board" />
        <NavLink to="/patients" label="Patients" />
        <NavLink to="/sessions" label="Sessions" />
        <NavLink to="/account" label="Account" />
        <NavLink to="/logout" label='Logout' />
        <div className="divider" />
        <NavLink to="/devices" label="Devices" />
        <div className="divider" />
        <NavLink to="/customers" label="Customers" />
      </Nav>
    )
      
  }
  if (isAuthenticated && user && user.role === 'customer_admin') {
    return (
      <Nav className="me-auto">
        <NavLink to="/vitalsboard" label="Vitals Board" />
        <NavLink to="/patients" label="Patients" />
        <NavLink to="/sessions" label="Sessions" />
        <NavLink to="/settings/pims" label="PIMS Settings" />
        <NavLink to="/account" label="Account" />
        <NavLink to="/logout" label='Logout' />
        <div className="divider" />
        <NavLink to="/devices" label="Devices" />
      </Nav>
    )
  }

  return (
    <Nav className="me-auto">
      {!isAuthenticated && <NavLink to="/organization-setup" label="Account Creation" />}
      {!isAuthenticated && <NavLink to="/login" label='Login' />}
      {!isAuthenticated && <NavLink to="/password-reset" label='Reset Password' />}
    </Nav>
  );
};

export default NavLinksMolecule;
